const Loading = () => {
  return (
    <div className="flex flex-col bg-daresidepanelbg justify-between h-screen text-dashboardtext p-8">
      <h1 className="font-ocr text-dashboardtext text-3xl">Loading</h1>
    </div>
  )
}

export default Loading
